import { render, staticRenderFns } from "./BoletimMedicaoHistorico.vue?vue&type=template&id=40146db0&scoped=true&"
import script from "./BoletimMedicaoHistorico.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoHistorico.vue?vue&type=script&lang=js&"
import style0 from "./BoletimMedicaoHistorico.vue?vue&type=style&index=0&id=40146db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40146db0",
  null
  
)

export default component.exports